import { createSlice } from '@reduxjs/toolkit';
import { fetchLicenseAccessDetails } from '../../dispatchers/WidgetAccessDispatcher';
import { AccessiableWidget, LicenseInfo } from '../../models/LicenseWidget';

interface State {
    data: LicenseInfo;
    loading: boolean;
    error: string | undefined;
    accessibleWidgets: AccessiableWidget[];
}

const initialState: State = {
    data: [] as unknown as LicenseInfo,
    loading: false,
    error: undefined,
    accessibleWidgets: [],
};

const widgetAccessSlice = createSlice({
    name: 'widgetAccess',
    initialState,
    reducers: {
        setInitialState: (state) => {
            state.data = [] as unknown as LicenseInfo;
            state.error = undefined;
            state.loading = false;
            state.accessibleWidgets = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLicenseAccessDetails.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchLicenseAccessDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                console.log('action.payload::', action.payload);
            })
            .addCase(fetchLicenseAccessDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Something went wrong';
            });
    },
});

export const {
    setInitialState
} = widgetAccessSlice.actions;

export default widgetAccessSlice.reducer;
